import { useQuery } from '@/hooks/query.hook';
import UploadKeyToken from '../chatGPT/upload-key-token.home';

export default function UploadKeyTokenPermission() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      default:
        return <UploadKeyToken />;
    }
  };
  return <>{renderContent()}</>;
}
